import React, { useEffect, useState } from "react";
import { FaPlus, FaTrashAlt } from "react-icons/fa";
import TextFieldCustom from "../../../component/elements/textfieldCustom";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import axiosInstance from "../../../configuration/request";
import { useSnackbar } from "../../../component/SnackbarContext";

export default function ChecklistManagement() {
  const [checklistItems, setChecklistItems] = useState([]);
  const [newTitle, setNewTitle] = useState("");
  const showSnackbar = useSnackbar();

  useEffect(() => {
    fetchCheckList();
  }, []);

  const fetchCheckList = async () => {
    try {
      const res = await axiosInstance.get(`/customer/core/dropdown/checklist`);
      setChecklistItems(res?.data?.value);
    } catch (error) {
      showSnackbar(
        error?.response?.data?.message || "Something went wrong!",
        "error"
      );
    }
  };

  const addToChecklist = async () => {
    if (!newTitle.trim()) return;
    if (checklistItems?.length > 5) {
      showSnackbar("Max 5 items allowed. Remove one to add more.", "error");
      return;
    }
    const updatedChecklist = [...checklistItems, newTitle.trim()];
    const payload = {
      key: "checklist",
      values: updatedChecklist,
    };
    await saveChecklist(payload);
    showSnackbar("Checklist updated successfully!", "success");
  };

  const saveChecklist = async (payload) => {
    try {
      await axiosInstance.post(`/customer/core/dropdown`, payload);
      fetchCheckList();
    } catch (error) {
      showSnackbar(
        error?.response?.data?.message || "Something went wrong!",
        "error"
      );
    }
  };

  const handleDeleteItem = async (value) => {
    const updatedList = checklistItems.filter((item) => item !== value);
    const payload = {
      key: "checklist",
      values: updatedList,
    };
    await saveChecklist(payload);
    showSnackbar("Checklist item deleted successfully!", "success");
  };

  return (
    <div className="border rounded-lg p-6 space-y-6 w-full max-w-4xl mx-auto">
      {/* Add New Checklist Item */}
      <div className="border rounded-lg bg-blue-50 p-4 mb-6">
        <h4 className="mb-2 font-medium">Add New Checklist Item</h4>
        <div className="flex gap-3">
          <TextFieldCustom
            fullWidth
            placeholder="Item Name*"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
          />
          <CustomButton
            onClick={addToChecklist}
            customeClass="gradient-button w-[150px] h-[50px]"
          >
            <FaPlus className="mr-1" /> Add
          </CustomButton>
        </div>
      </div>

      {/* Current Checklist */}
      <h4 className="mb-2 font-medium text-gray-800">
        Current Checklist Items
      </h4>
      {checklistItems.length === 0 ? (
        <p className="text-gray-400 text-center py-8">
          No checklist items found. Add your first item above.
        </p>
      ) : (
        <div className="space-y-3">
          {checklistItems.map((item, index) => (
            <div
              key={item.id}
              className="flex items-center justify-between gap-3 p-4 border rounded-lg bg-gray-50 shadow-sm hover:shadow-md transition"
            >
              <div className="flex justify-center items-center gap-3">
                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-sm font-medium text-blue-600">
                  {index + 1}
                </div>
                <div className="text-lg font-semibold text-gray-800">
                  {item}
                </div>
              </div>
              <button
                className="p-2 text-red-500 hover:bg-red-100 rounded transition"
                type="button"
                onClick={() => handleDeleteItem(item)}
              >
                <FaTrashAlt />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
